import { Routes, Route } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import AdminPage from 'pages/AdminPage';
import DashboardPage from 'pages/DashboardPage';
import ContractPage from 'pages/ContractPage';
import ContractList from 'components/contract/ContractList';
import ContractCreator from 'components/contract/contractCreator/ContractCreator';
import ContractViewer from 'components/contract/contractViewer/ContractViewer';
import PlacePage from 'pages/PlacePage';
import PlaceList from 'components/place/PlaceList';
import PlaceCreator from 'components/place/PlaceCreator';
import PlaceViewer from 'components/place/PlaceViewer';
import ErrorPage from 'pages/ErrorPage';
import DevicePage from 'pages/DevicePage';
import DeviceList from 'components/device/DeviceList';
import DeviceRegister from 'components/device/DeviceRegister';
import DashboardTable from 'components/dashboard/DashboardTable';
import DashboardViewer from 'components/dashboard/DashboardViewer';
import ErrorDashboardTable from 'components/error/ErrorDashboardTable';
import ServiceDashboardPage from 'pages/ServiceDashboardPage';
import ServiceUsersPage from 'pages/ServiceUsersPage';
import ServiceSensorChartPage from 'pages/ServiceSensorChartPage';
import ServiceRegisterFormPage from 'pages/ServiceRegisterFormPage';
import NotificationPage from 'pages/NotificationPage';
import DeviceRegisterFloor from 'components/device/DeviceRegisterFloor';
import DeviceRegisterSpace from 'components/device/DeviceRegisterSpace';
import DeviceRegisterBox from 'components/device/DeviceRegisterBox';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import FindIdForm from 'components/auth/FindIdForm';
import ResetPasswordForm from 'components/auth/ResetPasswordForm';
import SMSAuthPage from 'pages/SMSAuthPage';
import AccountsPage from 'pages/AccountsPage';
import AccountCreatePage from 'pages/AccountCreatePage';
import EmailAuthPage from 'pages/EmailAuthPage';
import RegisterPoCForm from 'components/service/RegisterPoCForm';
import { PrivacyPolicy } from 'pages/PrivacyPolicy';
import { Toaster } from 'react-hot-toast';
import { TermsOfService } from 'pages/TermsOfService';

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/findId" element={<FindIdForm />} />
        <Route path="/resetPassword" element={<ResetPasswordForm />} />
        <Route path="/SMSAuth" element={<SMSAuthPage />} />
        <Route path="/emailAuth" element={<EmailAuthPage />} />
        <Route path="/reset/:id/:level/:type" element={<ResetPasswordPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/admin" element={<AdminPage />}>
          <Route index element={<DashboardViewer />} />
          <Route path="dashboard" element={<DashboardPage />}>
            <Route path="place" element={<DashboardTable place />} />
            <Route path="device" element={<DashboardTable />} />
          </Route>
          <Route path="contracts" element={<ContractPage />}>
            <Route index element={<ContractList />} />
            <Route path=":id" element={<ContractViewer />} />
            <Route path="creator" element={<ContractCreator />} />
            <Route path="editor" element={<ContractCreator edit />} />
          </Route>
          <Route path="places" element={<PlacePage />}>
            <Route index element={<PlaceList />} />
            <Route path=":id/creator" element={<PlaceCreator />} />
            <Route path=":id" element={<PlaceViewer />} />
            <Route path=":id/editor" element={<PlaceCreator edit />} />
          </Route>
          <Route path="devices" element={<DevicePage />}>
            <Route index element={<DeviceList />} />
            <Route path=":id/register" element={<DeviceRegister />}>
              <Route index element={<DeviceRegisterFloor />} />
              <Route path=":floor" element={<DeviceRegisterSpace />} />
              <Route path=":floor/:space" element={<DeviceRegisterBox />} />
            </Route>
          </Route>
          <Route path="error" element={<ErrorPage />}>
            <Route index element={<ErrorDashboardTable />} />
            <Route path="done" element={<ErrorDashboardTable done />} />
          </Route>
          <Route path="notification" element={<NotificationPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="accountCreate" element={<AccountCreatePage />} />
        </Route>
        <Route path="/service" element={<ServiceDashboardPage />} />
        <Route path="/service/:id" element={<ServiceSensorChartPage />} />
        <Route path="/service/users" element={<ServiceUsersPage />} />
        <Route path="/service/register" element={<ServiceRegisterFormPage />} />
        <Route path="/service/register/poc" element={<RegisterPoCForm />} />
      </Routes>
      <Toaster />
    </>
  );
};

export default App;
